import apiClient from '@/services/axios'

export async function get(venueId) {
  var response = await apiClient.get('/venues/' + venueId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get Venue.')
}
